<style scoped>
	#app {
		padding: 20px;
	}
	.header {
		line-height: 60px;
		font-size: 16px;
		font-weight: bold;
		
	}
	.table-box {
		margin-top: 10px;
		background-color: white;
		width: 100%;
		border-radius: 3px;
		border:solid 1px #ECECEC;
	}
	
	.table-header {
		padding: 15px 20px;
		font-size: 14px;
		font-weight: bold;
		display: flex;
		flex-direction: row;
		justify-content: space-between;
	}
	
	.box {
		background-color: white;
		width: 100%;
		border-radius: 3px;
		border:solid 1px #ECECEC;
		display: flex;
		flex-wrap: wrap;
		padding: 10px 0;
		font-size: 14px;
	}
	.form-item {
		height: 60px;
		width: 380px;
		display: flex;
		flex-direction: row;
		align-items: center;
	}
	.form-name {
		width: 120px;
		text-align: right;
	}
	.inp {
		width: 280px;
	}
	.el-button--primary {
		background-color: #1677FF!important;
	}
	.dot {
		color: #52C51A;
		padding: 10px;
	}
	.il {
		display: flex;
		flex-direction: row;
	}
	.t-box {
		border: solid 1px #dcdcdc;
		padding: 0 4px;
		border-radius: 4px;
	}
	.t-box1 {
		border: solid 1px #3da113;
		color: #3da113;
		padding: 0 4px;
		border-radius: 4px;
		background-color: #F7FFFE;
	}
	.t-edit {
		font-size: 14px;
		padding: 0 4px;
		margin-left: 10px;
		cursor: pointer;
	}
	.t-a {
		color: #1677FF;
		text-decoration: underline;
		cursor: pointer;
	}
</style>
<template>
	<div id="app">
		<el-breadcrumb class="nav" separator="/" style="margin-bottom: 13px;">
			<el-breadcrumb-item>开发配置</el-breadcrumb-item>
			<el-breadcrumb-item>竞彩足球开奖</el-breadcrumb-item>
		</el-breadcrumb>
		
		<div class="box">
			<div class="form-item">
				<div style="width: 400px; margin-left: 20px;">
					<el-button size="medium" type="primary" @click="getData()">刷新</el-button>
				</div>
			</div>
		</div>
		
		<div class="table-box">
			<el-table :data="tableData" border 
				v-loading="loading"
				element-loading-text="拼命加载中"
				element-loading-spinner="el-icon-loading"
				element-loading-background="rgba(0, 0, 0, 0.8)" >
			    <el-table-column prop="id" label="ID" width="80" align="center"></el-table-column>
				<el-table-column prop="match_id" label="比赛ID" align="center" width="120"></el-table-column>
				<el-table-column prop="issue_week" label="场次" align="center" width="120"></el-table-column>
				<el-table-column prop="status" label="主队 VS 客队" align="center"  width="220">
					<template slot-scope="scope">
						{{scope.row.short_home}} VS {{scope.row.short_away}}
					</template>
				</el-table-column>
				<el-table-column prop="openStatus" label="状态" align="center" width="140">
					<template slot-scope="scope">
						<el-tag type="info" v-if="scope.row.openStatus==0" size="mini">未获取</el-tag>
						<el-tag type="success" v-if="scope.row.openStatus==1" size="mini">已获取</el-tag>
					</template>
				</el-table-column>
				
				<el-table-column prop="tags" label="半场比分" align="center" width="140">
					<template slot-scope="scope">
						<div v-if="scope.row.openStatus==1">
							{{scope.row.resultRow.half_home_score}}:{{scope.row.resultRow.half_away_score}}
						</div>
					</template>
				</el-table-column>
				<el-table-column prop="tags" label="全场比分" align="center" width="140">
					<template slot-scope="scope">
						<div v-if="scope.row.openStatus==1">
							{{scope.row.resultRow.home_score}}:{{scope.row.resultRow.away_score}}
						</div>
					</template>
				</el-table-column>
				<el-table-column prop="tags" label="赛果" align="center">
					<template slot-scope="scope">
						<div v-if="scope.row.openStatus==1">
							<div>{{scope.row.resultRow.spf}}</div>
							<div>{{scope.row.resultRow.rq}}</div>
							<div>{{scope.row.resultRow.bf}}</div>
							<div>{{scope.row.resultRow.jq}}</div>
							<div>{{scope.row.resultRow.bqc}}</div>
						</div>
					</template>
				</el-table-column>
				<el-table-column prop="match_time" label="比赛时间"  align="center">
					<template slot-scope="scope">
						{{formatTimestamp(scope.row.match_time)}}
					</template>
				</el-table-column>
				
				<el-table-column prop="status" label="操作" fixed="right" align="center">
					<template slot-scope="scope">
						<el-button type="primary" @click="editFunc(scope)" size="mini">编辑</el-button>
					</template>
				</el-table-column>
				
			  </el-table>
			  
			  <div  style="flex-grow: 1; display: flex; flex-direction: row; justify-content: flex-end; margin: 10px 10px 10px 0;">
			  <el-pagination
			        @size-change="handleSizeChange"
			        @current-change="handleCurrentChange"
			        :current-page="currentPage"
			        :page-sizes="[10, 20, 50, 100]"
			        :page-size="limit"
			        layout="total, sizes, prev, pager, next, jumper"
			        :total="total">
			      </el-pagination>
			  </div>
		</div>
		
		
		<el-dialog title="获取赛果" :visible.sync="dialogVisible1" v-if="dialogVisible1" width="700px" :before-close="handleClose">
		  <editRate :ruleForm="editInfo"></editRate>
		</el-dialog>
	</div> 
</template>

<script>
	import editRate from './editFootballRate.vue';
	
	export default {
		components:{
			editRate
		},
		computed:{
		},
		data(){
			return {
				dialogVisible1:false,
				dialogVisible:false,
				loading:false,
				currentPage:1,
				tableData: [],
				total:0,
				limit:10,
				editInfo:{}
			}
		},
		created() {
			this.getData();
		},
		methods:{
			editFunc(scope){
				this.editInfo = scope.row;
				this.dialogVisible1 = true;
			},
			handleClose(){
				this.dialogVisible = false;
				this.dialogVisible1 = false;
			},
			getData(){
				let that = this;
				that.loading = true;
				that.$api.post("/Open/getFootballMatchs", {page:this.currentPage, limit:this.limit}).then(res=>{
					that.loading = false;
					that.tableData = res.data.list;
					that.total = res.data.total;
				}).catch(res=>{
					that.loading = false;
				});
			},
			handleSizeChange(e){
				this.limit = e;
				this.getData();
			},
			handleCurrentChange(e){
				this.currentPage = e;
				this.getData();
			},
			formatTimestamp(ts) {
				if(ts == 0){
					return '';
				}
				// 如果是 10 位（秒），需要乘 1000 变成毫秒
				if (ts.toString().length === 10) {
					ts *= 1000
				}
				const date = new Date(ts)
			
				const Y = date.getFullYear()
				const M = String(date.getMonth() + 1).padStart(2, '0')
				const D = String(date.getDate()).padStart(2, '0')
			
				const h = String(date.getHours()).padStart(2, '0')
				const m = String(date.getMinutes()).padStart(2, '0')
				const s = String(date.getSeconds()).padStart(2, '0')
			
				return `${Y}-${M}-${D} ${h}:${m}:${s}`
			},
		}
	}
</script>

